import { parseHospitalSynchronizedAtMs } from '../user/auth'

export const formatHospitalSynchronizedAt = (
  raw: string | null
): string | null => {
  const millis = parseHospitalSynchronizedAtMs(raw)

  if (millis === null) {
    return null
  }

  const date = new Date(millis)

  if (Number.isNaN(date.getTime())) {
    return null
  }

  return date.toLocaleString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  })
}

export const formatHospitalSelectLabel = (
  hospitalName: string,
  syncLabel: string | null
): string =>
  syncLabel
    ? `${hospitalName} - Última atualização em ${syncLabel}`
    : hospitalName
